import React, { Component } from 'react';
import 'react-tabs/style/react-tabs.css';
import Header from '../../layout/Header';


export class OrofacialPainClinic extends Component {
    render() {
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row bestpractices-banner">
                    <div className="container-xl">
                    <div className="row">
                        <div className="col-md-12"> 
                        <div className="title-box text-center">
                            <div className="page-title-heading  card_box">
                            <h4 className="title" style={{color:"white"}}>Orofacial Pain Clinic  </h4>
                            <div className="ttm-color-home">
                            <span>
                                <a className="ttm-color-home" title="Homepage" href={process.env.PUBLIC_URL + '/'}><i className="ti ti-home" />&nbsp;&nbsp;Home</a>
                            </span>
                            <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                            <span>VSDCH</span>
                            </div>  
                        </div>
                        </div>{/* /.col-md-12 */}
                        </div>{/* /.page-title-captions */}  
                    </div>{/* /.row */}  
                    </div>{/* /.container */}                     
                </div>
                <section className="ttm-row aboutus-section clearfix">
                    <div className="container-xl">
                    <div className="row">{/* row */}
                        <div className="col-lg-6">
                        {/* section title */}
                        <div className="section-title with-desc clearfix">
                            <div className="title-header">                        
                            <h2 className="title">About  <span>Orofacial Pain Clinic</span></h2>
                            </div>
                            <div className="title-desc">
                            <p> Dept of Oral Medicine and Radiology, VSDCH initiated a special Clinic/ Centre for Orofacial pain management on 12th November 2020</p>
                            <p>Facilities available in the pain clinic are</p>                         
                            </div>
                        </div>{/* section title end */}
                        {/* row */}
                        <div className="row no-gutters mt-4 mb-4">
                            <div className="col-md-6 col-lg-6 col-sm-6">
                            <ul className="ttm-list ttm-list-style-icon">
                                <li><i className="ti-check-box ttm-textcolor-skincolor" /><span className="ttm-list-li-content">TENS </span></li>
                                <li><i className="ti-check-box ttm-textcolor-skincolor" /><span className="ttm-list-li-content"> Therapeutic Ultrasound </span></li>
                            </ul>
                            </div>
                            <div className="col-md-6 col-lg-6 col-sm-6">
                            <ul className="ttm-list ttm-list-style-icon">
                                <li><i className="ti-check-box ttm-textcolor-skincolor" /><span className="ttm-list-li-content"> Laser</span></li>
                                <li><i className="ti-check-box ttm-textcolor-skincolor" /><span className="ttm-list-li-content">Acupuncture</span></li>
                            </ul>
                            </div>
                        </div>{/* row END*/}
                      
                        </div>
                        <div className="col-lg-6">
                        <div className="position-relative res-991-mt-30">
                            {/* ttm_single_image-wrapper */}
                            <div className="ttm_single_image-wrapper text-sm-center">
                            <img className="img-fluid" src="./images/Orofacialpainclinicimage2.jpg" title="single-img-seven" alt="single-img-seven" />
                            </div>{/* ttm_single_image-wrapper end */}
                        </div>
                        </div>
                    </div>
                    {/* row end */}
                    </div>
                </section>
            </div>
        )
    }
}


export default OrofacialPainClinic;